import { render, staticRenderFns } from "./CorpRegister.vue?vue&type=template&id=a0274776&scoped=true&"
import script from "./CorpRegister.vue?vue&type=script&lang=js&"
export * from "./CorpRegister.vue?vue&type=script&lang=js&"
import style0 from "./CorpRegister.vue?vue&type=style&index=0&id=a0274776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0274776",
  null
  
)

export default component.exports